export default __webpack_public_path__ + "static/media/add_new_task.cbe4b6d1.png";